import React, { useState } from 'react';
import {
  BlocksProvider,
  LayersProvider,
  StylesProvider,
  TraitsProvider,
} from '@grapesjs/react';
import CustomBlockManager from './CustomBlockManager';
import CustomStyleManager from './CustomStyleManager.jsx';
import CustomTraitManager from './CustomTraitManager';
import CustomLayerManager from './CustomLayerManager';

// Tab icons
const Icons = {
  palette: (p: any) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/>
      <circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/>
      <circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/>
      <circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/>
      <path d="M12 2a10 10 0 1 0 0 20 4 4 0 0 0 0-8h-2a2 2 0 0 1-2-2 2 2 0 0 1 2-2h2a4 4 0 0 0 4-4 2 2 0 0 0-2-2Z"/>
    </svg>
  ),
  page: (p: any) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z"/>
      <path d="M14 2v6h6M8 13h8M8 17h6"/>
    </svg>
  ),
  layers: (p: any) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="m12 2 9 5-9 5-9-5Z"/>
      <path d="m3 12 9 5 9-5M3 17l9 5 9-5"/>
    </svg>
  ),
  blocks: (p: any) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="3" y="3" width="6" height="6" rx="1"/>
      <rect x="15" y="3" width="6" height="6" rx="1"/>
      <rect x="3" y="15" width="6" height="6" rx="1"/>
      <rect x="15" y="15" width="6" height="6" rx="1"/>
    </svg>
  ),
};

const TABS = [
  { id: 0, label: 'Design', icon: Icons.palette },
  { id: 1, label: 'Page',   icon: Icons.page },
  { id: 2, label: 'Layers', icon: Icons.layers },
  { id: 3, label: 'Add',    icon: Icons.blocks },
];

interface RightSidebarProps {
  className?: string;
}

export default function RightSidebar({ className }: RightSidebarProps): React.ReactElement {
  const [tab, setTab] = useState(3); // default to "Add" (blocks)

  return (
    <aside className={`dreamx-panel ${className ?? ''}`}>
      {/* Tabs */}
      <div className="dx-panel-tabs">
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <button
              key={t.id}
              className={`dx-panel-tab${tab === t.id ? ' active' : ''}`}
              onClick={() => setTab(t.id)}
            >
              <Icon />
              {t.label}
            </button>
          );
        })}
      </div>

      {/* Panel body */}
      <div className="dx-panel-body">
        {tab === 0 && (
          <StylesProvider>
            {(props) => <CustomStyleManager {...props} />}
          </StylesProvider>
        )}

        {tab === 1 && (
          <TraitsProvider>
            {(props) => <CustomTraitManager {...props} />}
          </TraitsProvider>
        )}

        {tab === 2 && (
          <LayersProvider>
            {(props) => <CustomLayerManager {...props} />}
          </LayersProvider>
        )}

        {tab === 3 && (
          <BlocksProvider>
            {(props) => <CustomBlockManager {...props} />}
          </BlocksProvider>
        )}
      </div>
    </aside>
  );
}
